export default "__VITE_ASSET__W0XFK8Rn__"